import React from 'react'
import { Edit } from '../NewIcons'
import Chip from '../Chip/Chip'
import useTrans from '../../../hooks/useTrans'

const getChipLabel = (errore, t, index) => {
  if (errore?.riga?.articolo?.codice) {
    return errore.riga.articolo.codice
  }

  if (errore?.nome_lavorazione) {
    return errore.nome_lavorazione
  }

  if (errore?.riga?.articolo?.titolo) {
    return errore.riga.articolo.titolo
  }

  if (errore?.tipo) {
    return `${errore.tipo} #${index + 1}`
  }

  return t('Elemento {0}', [`#${index + 1}`])
}

const AlertGroup = ({
  tipo,
  errori = [],
  placeholder,
  variant,
  onChipClick,
  hideDefaultPrefix,
}) => {
  const t = useTrans()
  const rootClass = ['alert-group', variant ? `alert-group--${variant}` : '']
    .filter(Boolean)
    .join(' ')

  const renderPlaceholder = () => {
    if (typeof placeholder === 'string') {
      return <span dangerouslySetInnerHTML={{ __html: placeholder }} />
    }
    return <span>{placeholder}</span>
  }

  return (
    <div className={rootClass}>
      <p className="alert-group__content">
        {!hideDefaultPrefix && <strong>{t('Attenzione')}: </strong>}
        {renderPlaceholder()}
      </p>
      <div className="alert-group__chips">
        {errori.map((errore, index) => (
          <Chip
            key={
              errore?.riga?.id || errore?.personalizzazione_id || `${tipo || errore?.tipo}-${index}`
            }
            placeholder={getChipLabel(errore, t, index)}
            size="md"
            variant="alert-group"
            icon={!!onChipClick ? <Edit /> : undefined}
            iconPos="right"
            onClick={!!onChipClick ? () => onChipClick?.(errore) : undefined}
          />
        ))}
      </div>
    </div>
  )
}

export default AlertGroup
